import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { formatNumber, formatDate } from "../utils/greenMilesUtils";

const GreenMilesDemosTable = ({ hotels = [], sortState, onSort }) => {
  const navigate = useNavigate();
  const auth = useAuth();
  const token = auth.user?.access_token;

  const handleHotelClick = (hotelId) => {
    navigate(`/greenmiles/demos/${hotelId}`);
  };

  const SortableHeader = ({ column, children, className = "" }) => (
    <th className={`px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 transition-colors ${className}`} onClick={() => onSort(column)}>
      <div className="flex items-center space-x-1">
        <span>{children}</span>
        <span className="text-gray-400">{sortState?.column === column ? (sortState.direction === "asc" ? "↑" : "↓") : "↕"}</span>
      </div>
    </th>
  );

  // Vérifier que hotels est bien un tableau
  if (!Array.isArray(hotels) || hotels.length === 0) {
    return (
      <div className="bg-white shadow-md rounded-lg p-8 text-center">
        <div className="text-gray-500 text-lg">Aucun hôtel GreenMiles disponible pour le moment.</div>
      </div>
    );
  }

  return (
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <SortableHeader column="hName">Nom de l'hôtel demo</SortableHeader>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions moy/stay</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Rewards non utilisées</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {hotels?.map((hotel, index) => {
              const hasQrCodes = hotel.has_qr_codes === 1;
              const totalRooms = hotel.total_rooms_count || hotel.hNbRooms || 0;
              const qrRooms = hotel.qr_rooms_count || 0;
              const roomsWithoutQr = totalRooms - qrRooms;

              return (
                <tr key={hotel.hId || index} className={`hover:bg-gray-50 transition-colors cursor-pointer ${!hasQrCodes ? "bg-orange-25" : ""}`} onClick={() => handleHotelClick(hotel.hId)}>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <div>
                        <div className="text-sm font-medium text-gray-900 flex items-center">{hotel.hName}</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-medium">{hotel.avg_actions_per_stay || 0}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-medium">{hotel.rewards_claim_not_used || 0}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    <div className="flex items-center gap-3">
                      <button
                        onClick={async (e) => {
                          e.stopPropagation();
                          const newName = window.prompt("Nom de la copie", `${hotel.hName} (Copie)`);
                          if (newName === null) return;
                          try {
                            const resp = await fetch(`${process.env.REACT_APP_API_URL || "/api"}/greenmiles/demos/${hotel.hId}/duplicate`, {
                              method: "POST",
                              headers: {
                                "Content-Type": "application/json",
                                ...(token ? { Authorization: `Bearer ${token}` } : {}),
                              },
                              body: JSON.stringify({ name: newName }),
                            });
                            if (resp.ok) {
                              window.location.reload();
                            }
                          } catch (err) {}
                        }}
                        className="text-blue-600 hover:text-blue-800 font-medium"
                        title="Dupliquer la démo"
                      >
                        Dupliquer
                      </button>
                      <button
                        onClick={async (e) => {
                          e.stopPropagation();
                          const confirmed = window.confirm(`Êtes-vous sûr de vouloir supprimer définitivement la démo "${hotel.hName}" ?\n\nCette action supprimera :\n- L'hôtel et toutes ses chambres\n- Tous les séjours et données associées\n- Toutes les actions et récompenses\n- Tous les scans QR\n\nCette action est IRRÉVERSIBLE !`);
                          if (!confirmed) return;

                          try {
                            const resp = await fetch(`${process.env.REACT_APP_API_URL || "/api"}/greenmiles/demos/${hotel.hId}`, {
                              method: "DELETE",
                              headers: {
                                "Content-Type": "application/json",
                                ...(token ? { Authorization: `Bearer ${token}` } : {}),
                              },
                            });

                            if (resp.ok) {
                              const result = await resp.json();
                              alert(`Démo "${hotel.hName}" supprimée avec succès !`);
                              window.location.reload();
                            } else {
                              const error = await resp.json();
                              alert(`Erreur lors de la suppression : ${error.message || "Erreur inconnue"}`);
                            }
                          } catch (err) {
                            alert("Erreur de connexion lors de la suppression");
                          }
                        }}
                        className="text-red-600 hover:text-red-800 font-medium"
                        title="Supprimer définitivement la démo"
                      >
                        Supprimer
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GreenMilesDemosTable;
